import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ClipBoardService } from '../../../services/clipboard.service'
import { ServerService } from '../../../services/server.service'
@Component({
    selector: 'user-edit-modal',
    templateUrl: './user-edit-modal.component.html',
    styleUrls: ['./user-edit-modal.component.scss']
})
export class UserEditModalComponent implements OnInit {
  authToken = localStorage.getItem("token")
  public userInfo = JSON.parse(localStorage.getItem("userInfo"));
  btnStatus: boolean = false
  editUserForm: FormGroup;
  constructor(
      private serverService: ServerService,
      private clipBoardService: ClipBoardService,
      private fb: FormBuilder,
      private dialogRef: MatDialogRef<UserEditModalComponent>,
      @Inject(MAT_DIALOG_DATA) private data
  ) {
    // console.log(this.data)
          this.editUserForm = this.fb.group({
              name: [this.data.name],
              email: [this.data.email,Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')],
              phone: [this.data.phone],
              address: [this.data.address],
              telephony: [this.data.telephony_number],
          })
     
  }

  ngOnInit() {
  }

  save() {
      this.btnStatus = true
      let body = {}
     
          body = {
            "name": this.editUserForm.value.name,
            "email": this.editUserForm.value.email,
            "phone": this.editUserForm.value.phone,
              "address": this.editUserForm.value.address,
              "telephony_number": this.editUserForm.value.telephony_number
          }
     
      
      this.serverService.adminUpdateUser(this.data.id,body, this.authToken).subscribe(
          data => {
              this.btnStatus = false
              this.clipBoardService.showMessgeInText('Updated User  Details Successfully', 'success-snackbar')
              this.dialogRef.close(data)
          },
          err => {
              this.btnStatus = false
              this.clipBoardService.checkServerError(err, this.authToken)
          }
      )
  }

  close() {
      this.dialogRef.close();
  }

  onKeyPress(event: KeyboardEvent) {
  const inputElement = event.target as HTMLInputElement;
  const inputValue = inputElement.value;
  
  // Get the position of the cursor in the input
  const cursorPosition = inputElement.selectionStart;

  // Allow only if the key pressed is a number (0-9)
  const allowedCharacters = /[0-9]/;

  // Check if the key pressed is the plus sign
  if (event.key === '+') {
    // Prevent typing if the plus sign is not at the first index
    if (cursorPosition !== 0) {
      event.preventDefault();
    } else {
      // Prevent typing if a plus sign already exists in the input
      if (inputValue.includes('+')) {
        event.preventDefault();
      }
    }
  } else {
    // Prevent typing if the key pressed is not a number (0-9)
    const inputChar = event.key;
    if (!allowedCharacters.test(inputChar)) {
      event.preventDefault();
    }
  }
}

}
